import React, { Component } from "react";

import { GipInsuredContainer } from "./gip-insured-style";

interface GipInsuredProps {
  age: number;
  birthDate: string;
  checked: boolean;
  id: number;
  index: number;
  onClick: Function;
  hasAnotherInsurance?: boolean;

}


class GipInsuredItem extends Component<GipInsuredProps> {


  render() {

    const {
      age,
      birthDate,
      id,
      hasAnotherInsurance,
      onClick,
    } = this.props


    return (
      <GipInsuredContainer>
        <div className="tab">
            <label className="tab-label">
              <span>{`Asegurado ${id}`}</span>
              <span>{birthDate}</span>
              <span>{age} años</span>
            {
              hasAnotherInsurance ?
                <div className="colSin-10">
                  <span className="salud">Salud</span>
                </div> :
                <div className="colSin-10">
                  <></>
                </div>
            }
              <span className="delete" onClick={() => onClick()}></span>
            </label>
        </div>

      </GipInsuredContainer>
    )

  }
}

export default GipInsuredItem;



